import React from 'react';
import {
    Card,
    SimpleTable,
    DatePeriodColumn,
    MultiSelectSearch,
    DefaultSelectSearch, DatePeriodSearch,
} from 'components';
import {
    IExam, ILinkedExpertStatus, IQualificationInfoList,
} from 'components/models';
import { formatFullAddress, formatQualification } from '_helpers';
import { IQualificationsFilters, IExamsFilters } from '../../reduxModels';
import { useMultiSearch } from 'hooks';
import { PaginationImpl } from '../../defaultValues';
import EmptyIcon from 'components/assets/svg/news_icon.svg';

const Exams: React.FC<IProps> = (
  {
      getList,
      examsList,
      handleRowClick,
      cardTitle,
      cardCategory,
      ...props
  },
) => {
    React.useEffect(() => {
        if (props.getQualifications) props.getQualifications({ pageSize: 500 });
    }, []);

    const { filters, filterSetter, changeFilter } = useMultiSearch<IExamsFilters>(getList || (() => true), {});

    const examsTableHeaders = [
        { title: 'ПЕРИОД ПРОВЕДЕНИЯ' },
        { title: 'СПЕЦИАЛЬНОСТЬ И ПЛОЩАДКА' },
        { title: 'РОЛЬ В МЕРОПРИЯТИИ' },
        //{ title: 'ДНЕЙ УЧАСТИЯ' },
    ];

    const createListTableData = (exams: IExam[]) => exams.map(exam => ({
        id: exam.id,
        columns: [
            <DatePeriodColumn
              dateFrom={exam.date}
              dateTo={exam.lastDate}
            />,
            <div>
                <div className="row-title">
                    {exam.qualificationTitle}
                </div>
                <div className="row-subtitle">
                    {exam.accreditationCenterName}
                </div>
                <div className="row-subtitle">
                    {formatFullAddress(exam)}
                </div>
            </div>,
            'Член АПК',
            //'1',
        ],
    }));

    const onRowClick = (itemId: string) => {
        if (handleRowClick) {
            handleRowClick(itemId);
        }

        return true;
    };

    const showFilter = (!!examsList && !!examsList.total) || !!Object.keys(filters).length;

    return (
      <Card
        title={cardTitle || 'Участие в аккредитациях'}
        category={cardCategory || 'Список всех аккредитаций с участием специалиста'}
        cardClassName="border-0"
        withoutPadding
      >
          <MultiSelectSearch hide={!showFilter}>
              {props.qualifications && (<DefaultSelectSearch
                label="СПЕЦИАЛЬНОСТЬ"
                options={props.qualifications.items.map(q => ({
                    label: formatQualification(q),
                    value: q.id,
                }))}
                placeholder="Выберите специальность"
                onChange={e => changeFilter({
                    qualificationIds: [e.value],
                })}
              />)}
              <DatePeriodSearch
                onChange={changeFilter}
                setFrom={filterSetter('from')}
                setTo={filterSetter('from')}
                to={filters.to}
                from={filters.from}
              />
          </MultiSelectSearch>
          <SimpleTable
            tableRows={examsList ? createListTableData(examsList.items) : []}
            tableHeaders={examsTableHeaders}
            handleRowClick={onRowClick}
            pagination={new PaginationImpl(examsList).getPaginationData()}
            onPagination={p => changeFilter({
                pageSize: p.perPage,
                page: p.page,
            })}
            placeholderIcon={EmptyIcon}
            placeholderTitle="Нет ничего в списке"
            placeholderText="Здесь будут отображаться все аккредитации, в которых участвовал член аккредитационной комиссии"
          />
      </Card>
    );
};

export interface IProps {
    examsList?: IList | null;
    linkedExpertStatus?: ILinkedExpertStatus[];
    cardTitle?: string;
    cardCategory?: string;
    getList?: (data: IExamsFilters) => void;
    handleRowClick?: (id: string) => void;
    qualifications?: IQualificationInfoList | null;
    getQualifications?: (payload: IQualificationsFilters) => void;
}

export interface IList {
    items: IExam[];
    page: number;
    pageSize: number;
    total: number;
}

export default Exams;
